export default __webpack_public_path__ + "static/media/warning.34391f0b.svg";